import '@/styles/index.css'
import ReactDOM from 'react-dom/client';
import App from './App';
import Modal from 'react-modal';


(Modal as any).setAppElement('#root');

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
